module.exports = __webpack_public_path__ + "static/media/movilgoFrente.16f85125.png";